import { createSelector } from "reselect";
import { RootState } from "../../store/store";

export const selectInsight = createSelector(
  (state: RootState) => state.dashboard.analyzerData,
  (state: RootState) => state.dashboard.scannerData,
  (state: RootState) => state.dashboard.loadingDashboardInsight,
  (analyzerData, scannerData, loadingDashboardInsight) => ({
    analyzerData,
    scannerData,
    loadingDashboardInsight,
  })
);

export const selectTopProducts = createSelector(
  (state: RootState) => state.dashboard.loadingTopProducts,
  (state: RootState) => state.dashboard.topProducts,
  (loadingTopProducts, topProducts) => ({
    loadingTopProducts,
    topProducts,
  })
);
